const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

const API_BASE_URL = '/heist/api';
const WEBSOCKET_BASE_URL = `${wsProtocol}//${window.location.host}/heist/ws`;

// const API_BASE_URL = 'http://localhost:8000/api';
// const WEBSOCKET_BASE_URL = 'ws://localhost:8000/ws';

export const createGame = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/create-game/`, { method: 'POST' });
        if (!response.ok) {
            throw new Error('Failed to create game');
        }
        return await response.json();
    } catch (error) {
        // console.error("Error creating game:", error);
        return null;
    }
};

export const createRemoteGame = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/create-remote-game/`, { method: 'POST' });
        if (!response.ok) {
            throw new Error('Failed to create remote game');
        }
        return await response.json();
    } catch (error) {
        // console.error("Error creating remote game:", error);
        return null;
    }
};

export const playMove = async (gameState, move, difficulty) => {
    try {
        const response = await fetch(`${API_BASE_URL}/play-move/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ gameState, move, difficulty }),
        });
        if (!response.ok) {
            throw new Error('Failed to play move');
        }
        return await response.json();
    } catch (error) {
        // console.error("Error playing move:", error);
        return null;
    }
};

export const connectToSocket = (roomId, onMessageCallback) => {
    const socket = new WebSocket(`${WEBSOCKET_BASE_URL}/game/${roomId}/`);

    socket.onopen = () => {
        // console.log('WebSocket connected');
    };

    socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        onMessageCallback(data);
    };

    socket.onclose = () => {
        // console.log('WebSocket disconnected');
    };

    socket.onerror = (error) => {
        // console.error('WebSocket error:', error);
    };

    return socket;
};

export const sendRevealTile = (socket, row, col, player) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({
            type: 'reveal_tile',
            payload: { row, col, player }
        }));
    }
};

export const sendCheckWord = (socket, selectedTiles) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({
            type: 'check_word',
            payload: { selected_tiles: selectedTiles }
        }));
    }
};

export const sendSwapTiles = (socket, fromTile, toTile) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({
            type: 'swap_tiles',
            payload: { from: fromTile, to: toTile }
        }));
    }
}; 